/* Sherrys Wardrobe | Reels carousel — no third-party libraries */
(() => {
  'use strict';
  if (window.SherrysReelsSliderInstalled) return;
  window.SherrysReelsSliderInstalled = true;

  const setup = (root) => {
    if (root.dataset.swvInitialized === 'true') return;
    const track = root.querySelector('[data-swv-track]');
    const prev = root.querySelector('[data-swv-prev]');
    const next = root.querySelector('[data-swv-next]');
    const items = Array.from(root.querySelectorAll('[data-swv-item]'));
    const dialog = root.querySelector('[data-swv-modal]');
    const modalVideo = root.querySelector('[data-swv-modal-video]');
    const reelLink = root.querySelector('[data-swv-reel-link]');
    const shopLink = root.querySelector('[data-swv-shop-link]');
    if (!track || !items.length) return;
    root.dataset.swvInitialized = 'true';

    // Respect customers on data-saver connections and reduced-motion devices.
    // Video previews remain clickable, but they won't autoplay under these settings.
    const autoplay = root.dataset.swvAutoplay === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      !navigator.connection?.saveData;
    const loop = root.dataset.swvLoop === 'true';
    const videos = Array.from(root.querySelectorAll('.swv__card video'));
    let observer;
    let raf = 0;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = () => track.scrollLeft <= 3;
    const atEnd = () => track.scrollLeft >= maxScroll() - 3;
    const arrows = () => {
      const scrollable = maxScroll() > 3;
      if (prev) prev.hidden = !scrollable || (!loop && atStart());
      if (next) next.hidden = !scrollable || (!loop && atEnd());
    };
    const navigate = (direction) => {
      const current = track.scrollLeft;
      const positions = items.map((item) => item.offsetLeft - track.offsetLeft);
      let target;
      if (direction === 1) {
        target = positions.find((pos) => pos > current + 3);
        if (target === undefined) target = loop ? 0 : maxScroll();
      } else {
        target = [...positions].reverse().find((pos) => pos < current - 3);
        if (target === undefined) target = loop ? maxScroll() : 0;
      }
      track.scrollTo({ left: Math.max(0, Math.min(maxScroll(), target)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => navigate(-1));
    if (next) next.addEventListener('click', () => navigate(1));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(arrows);
    }, { passive: true });
    window.addEventListener('resize', arrows, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(arrows).observe(track);
    requestAnimationFrame(arrows);

    // Play only clips that are visible inside the viewport, always muted.
    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      video.pause();
    });
    if (autoplay && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (entry.isIntersecting && !dialog.open && !document.hidden) {
            const attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
          } else video.pause();
        }
      }, { threshold: 0.65 });
      videos.forEach((video) => observer.observe(video));
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach((v) => v.pause());
      else if (observer) {
        // Recheck viewport by reconnecting the observer after returning.
        videos.forEach((v) => observer.unobserve(v));
        videos.forEach((v) => observer.observe(v));
      }
    });

    const closeModal = () => {
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.removeAttribute('poster');
      modalVideo.load();
      // The observer will handle videos becoming visible again on scroll.
      if (observer) {
        videos.forEach((v) => observer.unobserve(v));
        videos.forEach((v) => observer.observe(v));
      }
    };
    dialog.addEventListener('close', closeModal);
    dialog.querySelector('[data-swv-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    root.querySelectorAll('[data-swv-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const sourceVideo = button.closest('[data-swv-item]').querySelector('video');
        if (!sourceVideo || typeof dialog.showModal !== 'function') return;
        const source = sourceVideo.currentSrc || sourceVideo.querySelector('source')?.src || '';
        if (!source) return;
        videos.forEach((video) => video.pause());
        modalVideo.src = source;
        const poster = sourceVideo.getAttribute('poster');
        if (poster) modalVideo.poster = poster;
        modalVideo.muted = false;
        modalVideo.controls = true;
        const reelUrl = button.dataset.reelUrl || '';
        const shopUrl = button.dataset.shopUrl || '';
        reelLink.hidden = !reelUrl;
        shopLink.hidden = !shopUrl;
        if (reelUrl) reelLink.href = reelUrl;
        if (shopUrl) shopLink.href = shopUrl;
        dialog.showModal();
        const attempt = modalVideo.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      });
    });

    // In the Shopify editor, bring the selected block into view.
    root.addEventListener('shopify:block:select', (event) => {
      const selected = event.target.closest('[data-swv-item]');
      if (selected) track.scrollTo({ left: selected.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-swv-root]')) setup(scope);
    scope.querySelectorAll('[data-swv-root]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
